import {DIALOG_TYPE, LayoutConfig} from '@spartacus/storefront';
import {
    UigAddedToCartDialogComponent
} from '../components/uig-cart/uig-add-to-cart/uig-added-to-cart-dialog/uig-added-to-cart-dialog.component';

export const uigAddedToCartDialogLayoutConfig: LayoutConfig = {
    launch: {
        ADDED_TO_CART: {
            inlineRoot: true,
            component: UigAddedToCartDialogComponent,
            dialogType: DIALOG_TYPE.DIALOG,
        },
    },
};
